import ValeurPropreCountComponentController from './valeur.propre.count.component.controller';
import Template from './valeur.propre.count.component.tpl.html';

export default {
	bindings: {
		domaine: '<',
		id: '<',
		refreshKey: '<' // nouveau binding
	},
	template: Template,
	controller: ValeurPropreCountComponentController
};
